import { pb } from '../../../shared/api/pocketbase';
import type { Catalog, CatalogInput } from './types';

const COLLECTION = 'calalogs';

export const fetchCatalogs = async (): Promise<Catalog[]> => {
  return pb.collection(COLLECTION).getFullList<Catalog>({
    sort: 'order,subcategory',
    requestKey: null,
  });
};

export const createCatalog = async (input: CatalogInput): Promise<Catalog> => {
  const { order, subcategory, groups, ...texts } = input;
  return pb.collection(COLLECTION).create<Catalog>({ texts, order, subcategory, groups });
};

export const updateCatalog = async (id: string, input: CatalogInput): Promise<Catalog> => {
  const { order, subcategory, groups, ...texts } = input;
  return pb.collection(COLLECTION).update<Catalog>(id, { texts, order, subcategory, groups });
};

// Частичное обновление только полей сортировки (для стрелок ↑/↓).
export const patchCatalogSort = async (id: string, patch: { order?: number; subcategory?: number }): Promise<void> => {
  await pb.collection(COLLECTION).update(id, patch);
};

export const deleteCatalog = async (id: string): Promise<void> => {
  await pb.collection(COLLECTION).delete(id);
};
